<template>
<div class="chapter">
<div class="inner_page">
<div>
<img alt="" src="OEBPS/images/cover.jpg" style="height:100%;max-width:100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cvi.vue?7f2f36f8